<template>
  <div class="dataTable__empty">{{ emptyLabel ? emptyLabel : $t("global.empty.no_data_available") }}</div>
</template>

<script>
export default {
  name: "EmptyDataTableComponent",
  props: {
    emptyLabel: {
      type: String,
      required: false,
      default: "",
    },
  },
};
</script>

<style lang="scss" scoped>
.dataTable {
  &__empty {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 50px;
    margin-bottom: 30px;
  }
}
</style>
